// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Tile } from '../../tileSelect';
import { getPerMonthAbbrv, getAlternativePriceString } from '../../../../../store/configuratorSettings/selectors';
import OptionPriceExtended from '../../optionPriceExtended';
import type { Extra } from '../../../../../types/pdb';

type OwnProps = {|
  activeMethods: string[],
  blockCount: number,
  extra: Extra,
  toggleExtra: Function,
|};

type StateProps = {|
  alternativePriceString: string,
  postfix: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const canSelectTile = (methods: Array<string>) => methods.length === 0 || (methods.length === 1 && methods.includes('selected'));

const ExtraTile = ({
  activeMethods,
  alternativePriceString,
  blockCount,
  extra: {
    description,
    id,
    recurring,
    image,
    most_chosen,
    name,
    price,
  },
  toggleExtra,
  postfix,
}: Props) => {
  const isActive = activeMethods.length > 0;
  return (
    <Tile
      key={id}
      active={isActive}
      onClick={() => canSelectTile(activeMethods) && toggleExtra(id)}
      blocksPerRow={1}
      blockCount={blockCount}
      mostChosen={most_chosen}
    >
      <OptionPriceExtended
        id={id}
        title={name}
        alternativePriceString={alternativePriceString}
        recurring={recurring}
        price={parseFloat(price)}
        active={isActive}
        description={description}
        postfix={postfix}
        imageUrl={image && image.url && image.url.replace('__width__', '300')}
      />
    </Tile>
  );
};

const mapStateToProps = (state: any, ownProps: OwnProps): StateProps => ({
  alternativePriceString: getAlternativePriceString(state, ownProps.activeMethods),
  postfix: getPerMonthAbbrv(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(ExtraTile);
